import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import { sectionStatsFetchStateConfig } from "../../../../consts";

export const sectionStatsMeta = makeCrudStateReducer(
  sectionStatsFetchStateConfig
);
